import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"

const ImagePlaceholder: FC = (): ReactElement => (
    <svg width="34" height="28" viewBox="0 0 34 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M32.461 0H1.539C0.680028 0 0 0.680029 0 1.539V25.9474C0 26.8064 0.680028 27.4864 1.539 27.4864H32.461C33.32 27.4864 34 26.8064 34 25.9474L33.9999 1.539C33.9999 0.680029 33.3199 0 32.4609 0H32.461ZM24.3726 5.15367C25.6968 5.15367 26.7347 6.22736 26.7347 7.51575C26.7347 8.83989 25.661 9.87782 24.3726 9.87782C23.0485 9.87782 22.0106 8.80413 22.0106 7.51575C21.9748 6.1916 23.0485 5.15367 24.3726 5.15367ZM26.6632 21.4736H7.26534C6.76426 21.4736 6.44212 20.901 6.7285 20.5074L13.5285 9.69899C13.779 9.30534 14.3158 9.30534 14.6022 9.66322L18.7537 15.2464C18.9685 15.5685 19.4338 15.6043 19.72 15.3179L21.4379 13.6716C21.7243 13.3853 22.1895 13.4569 22.4042 13.7431L27.2 20.4716C27.4863 20.901 27.1642 21.4736 26.6631 21.4736L26.6632 21.4736Z"
            fill="url(#paint0_linear_22316_46156)"
        />
        <path
            d="M32.461 0H1.539C0.680028 0 0 0.680029 0 1.539V25.9474C0 26.8064 0.680028 27.4864 1.539 27.4864H32.461C33.32 27.4864 34 26.8064 34 25.9474L33.9999 1.539C33.9999 0.680029 33.3199 0 32.4609 0H32.461ZM24.3726 5.15367C25.6968 5.15367 26.7347 6.22736 26.7347 7.51575C26.7347 8.83989 25.661 9.87782 24.3726 9.87782C23.0485 9.87782 22.0106 8.80413 22.0106 7.51575C21.9748 6.1916 23.0485 5.15367 24.3726 5.15367ZM26.6632 21.4736H7.26534C6.76426 21.4736 6.44212 20.901 6.7285 20.5074L13.5285 9.69899C13.779 9.30534 14.3158 9.30534 14.6022 9.66322L18.7537 15.2464C18.9685 15.5685 19.4338 15.6043 19.72 15.3179L21.4379 13.6716C21.7243 13.3853 22.1895 13.4569 22.4042 13.7431L27.2 20.4716C27.4863 20.901 27.1642 21.4736 26.6631 21.4736L26.6632 21.4736Z"
            fill="url(#paint1_radial_22316_46156)"
            fillOpacity="0.2"
        />
        <defs>
            <linearGradient
                id="paint0_linear_22316_46156"
                x1="17"
                y1="0"
                x2="17"
                y2="27.4864"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor={THEME.COLORS.blue[200]} />
                <stop offset="1" stopColor="#3E3ED7" />
            </linearGradient>
            <radialGradient
                id="paint1_radial_22316_46156"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(17 13.7432) rotate(90) scale(13.7432 17)"
            >
                <stop stopColor="#081C41" stopOpacity="0" />
                <stop offset="1" stopColor="#081C41" />
            </radialGradient>
        </defs>
    </svg>
)

const ImageUpload: FC = (): ReactElement => (
    <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 23.94C12.9859 23.94 13.3834 23.5425 13.3834 23.0567V3.00365L22.129 11.7492C22.3057 11.9259 22.5266 12.0142 22.7474 12.0142C22.9683 12.0142 23.1891 11.9259 23.3658 11.7492C23.7192 11.3958 23.7192 10.8658 23.3658 10.5124L13.1185 0.265062C12.7651 -0.088354 12.2351 -0.088354 11.8817 0.265062L1.59014 10.5124C1.23672 10.8658 1.23672 11.3958 1.59014 11.7492C1.94355 12.1027 2.47353 12.1027 2.82696 11.7492L11.6167 3.00365V23.0567C11.6167 23.5425 12.0143 23.9399 12.5001 23.9399L12.5 23.94Z"
            fill={THEME.COLORS.blue[200]}
        />
        <path
            d="M0 28.1361C0 28.6219 0.397563 29.0195 0.883392 29.0195H24.1166C24.6024 29.0195 25 28.6219 25 28.1361C25 27.6502 24.6024 27.2527 24.1166 27.2527H0.883392C0.397563 27.2527 0 27.6061 0 28.1361Z"
            fill={THEME.COLORS.blue[200]}
        />
    </svg>
)

const assets = { ImagePlaceholder, ImageUpload }

export { assets as imageUploadAssets }
